// Plain cookie helpers usable by non-Vue modules (services, helpers).
// mixins/cookie.js re-exports these so there is a single implementation.

function buildAttributes(ttlInDays) {
  let attributes = '; path=/; SameSite=Lax';

  // Only emit Secure when actually served over https, so cookies still work on
  // a plain-http local dev server.
  if (typeof window === 'undefined' || window.location.protocol === 'https:') {
    attributes += '; Secure';
  }

  if (ttlInDays && ttlInDays > 0) {
    const date = new Date();
    date.setTime(date.getTime() + ttlInDays * 24 * 60 * 60 * 1000);
    attributes += '; expires=' + date.toUTCString();
  }

  return attributes;
}

export function setCookie(cookieName, value, ttlInDays) {
  document.cookie =
    cookieName + '=' + (value || '') + buildAttributes(ttlInDays);
}

export function getCookie(cookieName) {
  const name = cookieName + '=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }

  return null;
}

export function deleteCookie(cookieName) {
  document.cookie =
    cookieName +
    '=; Path=/; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
